export default "__VITE_ASSET__dgpvpgKr__"